import React, { useEffect, useState } from 'react';
import { collection, getDocs } from "firebase/firestore";
import { auth, db } from '../../firebase.init';
import { signOut } from 'firebase/auth';

const Admin = () => {
    const [users, setUsers] = useState([]);
    const userCollectionRef = collection(db, "users");

    useEffect(() => {
        const getUsers = async () => {
            const data = await getDocs(userCollectionRef);
            setUsers(data.docs.map(doc => ({ ...doc.data(), id: doc.id })));
        }
        getUsers();
    }, []);

    return (
        <div className='min-h-screen text-white'>
            <h1 className='text-4xl text-center my-5'>Welcome Myself</h1>
            <div className="overflow-x-auto">
                <table className="w-full text-left">
                    <thead>
                        <tr>
                            <th className='bg-[#00283a] p-2'></th>
                            <th className='bg-[#00283a] p-2'>Name</th>
                            <th className='bg-[#00283a] p-2'>Email</th>
                            <th className='bg-[#00283a] p-2'>Message</th>
                            <th className='bg-[#00283a] p-2 w-52'>Time</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user, i) => <tr
                            key={user.id}
                        >
                            <th className='bg-[#02162b] p-2 font-light'>{i + 1}</th>
                            <td className='bg-[#02162b] p-2 font-light'>{user?.name}</td>
                            <td className='bg-[#02162b] p-2 font-light'>{user?.email}</td>
                            <td className='bg-[#02162b] p-2 font-light break-all'>{user?.message}</td>
                            <td className='bg-[#02162b] p-2 font-light'>{user?.date}</td>
                        </tr>)}
                    </tbody>
                </table>
                <div className='flex justify-center'>
                    <button onClick={() => signOut(auth)} className='mt-10 btn btn-sm rounded-md capitalize w-52 h-9 text-white glass'> Logout </button>
                </div>
            </div>
        </div>
    );
};

export default Admin;